import { BrowserTypes, browserName, browserVersion } from 'react-device-detect';

const compareVersions = (v1: string, v2: string): number => {
  const v1Parts = v1.split('.').map(Number);
  const v2Parts = v2.split('.').map(Number);

  for (let i = 0; i < Math.max(v1Parts.length, v2Parts.length); i++) {
    const p1 = v1Parts[i] || 0;
    const p2 = v2Parts[i] || 0;
    if (p1 > p2) return 1;
    if (p1 < p2) return -1;
  }
  return 0;
};

export const isBrowserSupported = (): boolean => {
  if (!browserVersion) return true;

  const minVersions: Record<string, string> = {
    [BrowserTypes.Chrome]: '109',
    [BrowserTypes.Edge]: '121',
    [BrowserTypes.EdgeChromium]: '121',
    [BrowserTypes.Firefox]: '115',
    [BrowserTypes.Safari]: '15.4',
    [BrowserTypes.MobileSafari]: '15.4',
  };

  const minVersion = minVersions[browserName];

  if (!minVersion) return true;

  return compareVersions(browserVersion, minVersion) >= 0;
};

export const getDevice = () => {
  const userAgent = window.navigator.userAgent;
  return userAgent.match(/\(([^)]+)\)/)?.[1] || 'Unknown Device';
};

export function generateBid(ip: string) {
  window.Fingerprint2?.get(function (components) {
    components.push({ key: 'ip', value: ip });
    window.bid = window.Fingerprint2.x64hash128(components.map((pair) => pair.value).join(), 31);
  });
}
